/**
 * Спрайт Apple-эмодзи для пикеров — self-hosted, никаких системных эмодзи и
 * никакого CDN (правило владельца, 18.05.2026).
 *
 * 16.09.2026: два листа ОДНОЙ версии emoji-datasource-apple@15.0.1 (сетка
 * 61 колонка, координаты из @emoji-mart/data/sets/15/apple.json):
 *   64px — /emoji/apple-64.png, 4,4 МБ — для ретины (DPR ≥ 1.5: телефоны, Mac);
 *   32px — /emoji/apple-32.png, 1,7 МБ — для обычных мониторов (ячейка 28px).
 * Пикер пустой, пока лист не приехал, поэтому лист прогревается заранее
 * (ChatPage → prefetchEmojiPicker при тихом старте) и кэшируется nginx на 30 дней.
 */
export const APPLE_SPRITE_64 = "/emoji/apple-64.png";
export const APPLE_SPRITE_32 = "/emoji/apple-32.png";

export function appleSpriteUrl(): string {
  const dpr = typeof window !== "undefined" ? (window.devicePixelRatio || 1) : 2;
  return dpr >= 1.5 ? APPLE_SPRITE_64 : APPLE_SPRITE_32;
}
